module.exports = __webpack_public_path__ + "static/img/hknonpermanent.5498d732.jpg";